// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* { margin: 0; padding: 0; box-sizing: border-box; }

body {
  font-family: 'Inter', 'Segoe UI', sans-serif;
  background: #f0f4ff;
  color: #0B1554;
}

::-webkit-scrollbar { width: 5px; height: 5px; }
::-webkit-scrollbar-track { background: transparent; }
::-webkit-scrollbar-thumb { background: #c0c8e8; border-radius: 10px; }

input:focus, select:focus, textarea:focus {
  outline: none;
  border-color: #4f6ef7 !important;
  box-shadow: 0 0 0 3px rgba(79,110,247,0.12);
}

a { text-decoration: none; }

button { font-family: inherit; }
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA,IAAI,SAAS,EAAE,UAAU,EAAE,sBAAsB,EAAE;;AAEnD;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sBAAsB,UAAU,EAAE,WAAW,EAAE;AAC/C,4BAA4B,uBAAuB,EAAE;AACrD,4BAA4B,mBAAmB,EAAE,mBAAmB,EAAE;;AAEtE;EACE,aAAa;EACb,gCAAgC;EAChC,2CAA2C;AAC7C;;AAEA,IAAI,qBAAqB,EAAE;;AAE3B,SAAS,oBAAoB,EAAE","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');\n\n* { margin: 0; padding: 0; box-sizing: border-box; }\n\nbody {\n  font-family: 'Inter', 'Segoe UI', sans-serif;\n  background: #f0f4ff;\n  color: #0B1554;\n}\n\n::-webkit-scrollbar { width: 5px; height: 5px; }\n::-webkit-scrollbar-track { background: transparent; }\n::-webkit-scrollbar-thumb { background: #c0c8e8; border-radius: 10px; }\n\ninput:focus, select:focus, textarea:focus {\n  outline: none;\n  border-color: #4f6ef7 !important;\n  box-shadow: 0 0 0 3px rgba(79,110,247,0.12);\n}\n\na { text-decoration: none; }\n\nbutton { font-family: inherit; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
